module.exports = __webpack_public_path__ + "static/media/page-loader.490c2695.gif";